import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { observable, action } from 'mobx';
import stores from 'cd-eft/models/Stores';

const setStore = stores.AppStore.surveyEngineeringStore;

export class SOSpreadsheetVM {
  @observable props;
  constructor(props: any) {
    this.props = props;
  }

  //for checkboxes
  @observable checkboxes: Array<number> = [];

  @action.bound toggleCheckbox(e) {
    const i = Number(e.target.value);
    if (e.target.checked) {
      this.checkboxes = [...this.checkboxes, i];
    } else {
      const items = this.checkboxes.filter((p) => !(p === i));
      this.checkboxes = items;
    }
  }

  //delete button onClick functionality
  @action.bound deleteOffsetStationHandler(event: any) {
    event.preventDefault();
    this.checkboxes.forEach((e) => {
      setStore.stationOffsetObject.offsetStations[e].editing_status = 'delete';
      setStore.stationOffsetObject.alignmentStations[e].editing_status = 'delete';
    });
    setStore.stationOffsetObject.offsetStations = setStore.stationOffsetObject.offsetStations.filter(
      (item) => item.editing_status !== 'delete'
    );
    setStore.stationOffsetObject.alignmentStations = setStore.stationOffsetObject.alignmentStations.filter(
      (item) => item.editing_status !== 'delete'
    );
    this.checkboxes = [];
  }

  // add Row
  @action.bound addRow(i: number) {
    this.checkboxes = [];
    setStore.stationOffsetObject.offsetStations.splice(i, 0, setStore.initialOffsetStation);
    setStore.stationOffsetObject.alignmentStations.splice(i, 0, setStore.initialAlignmentStation);
  }

  // for graph
  @observable plotData = {};
  @observable targetDivID = 'so-graph-div';
  @observable windowOptions = {
    margins: { top: 10, right: 60, bottom: 40, left: 60 },
    height: 450,
    axis: { x: 'Distance (ft)', y: 'Elevation (ft)' },
    curveType: 'curveLinear',
  };

  // update all OffsetStations in Store
  @action.bound updateAllOffsetStations(e: any) {
    const value = e.target.value;
    const name = e.target.name;
    if (setStore.stationOffsetObject.offsetStations) {
      setStore.stationOffsetObject.offsetStations.forEach((item) => {
        item[name] = Number(value);
      });
    }
    setStore.initialOffsetStation[name] = Number(value);
  }

  // update single OffsetStation in Store
  @action.bound updateSingleOffsetStation(e: any) {
    const value = e.target.value;
    const name = e.target.name;
    const index = e.target.getAttribute('data-i');
    setStore.stationOffsetObject.offsetStations[index][name] = value;
    setStore.initialOffsetStation[name] = value;
    if (name === 'stationDistance') {
      setStore.stationOffsetObject.alignmentStations[index].stationDistance = value;
      setStore.stationOffsetObject.alignmentStations[index].distance = value;
      setStore.stationOffsetObject.alignmentStations[index].y =
        Number(setStore.stationOffsetObject.beginningY) + Number(value);
      setStore.stationOffsetObject.alignmentStations[index].stationName = Math.round(value);
    }
    this.refillPlotData(setStore.stationOffsetObject.offsetStations[index]);
  }

  // update single Offset in OffsetStation in Store
  @action.bound updateSingleOffset(e: any) {
    const value = e.target.value;
    const name = e.target.name;
    const i = e.target.getAttribute('data-i');
    const j = e.target.getAttribute('data-j');
    setStore.stationOffsetObject.offsetStations[i].offsets[j][name] = value;
    if (Number(j) === 1) {
      setStore.stationOffsetObject.alignmentStations[i].z =
        setStore.stationOffsetObject.offsetStations[0].entryMode === 'ROD'
          ? setStore.stationOffsetObject.offsetStations[i].hiElevation - value
          : value;
    }
    this.refillPlotData(setStore.stationOffsetObject.offsetStations[i]);
  }

  @action.bound setEntryMode(e: any) {
    if (setStore.stationOffsetObject.offsetStations) {
      setStore.stationOffsetObject.offsetStations.forEach((item) => {
        item.entryMode = e.target.value;
        item.offsetType = `TYPE_${e.target.value}`;
      });
    }
    setStore.initialOffsetStation.entryMode = e.target.value;
    setStore.initialOffsetStation.offsetType = `TYPE_${e.target.value}`;
    this.plotData = {};
  }

  @action.bound addOffsetStationHandler(e: any) {
    e.preventDefault();
    MessageCenter.clearMessages();
    const newStation = { ...setStore.initialOffsetStation };
    const stations = setStore.stationOffsetObject.offsetStations;
    const newDistance = Number(stations[stations.length - 1].stationDistance) + Number(stations[0].stationStep);
    newStation.stationDistance = newDistance;
    setStore.stationOffsetObject.offsetStations = [...stations, { ...newStation }];
    // new AlignmentStation
    const newAlignmentStation = { ...setStore.initialAlignmentStation };
    newAlignmentStation.stationDistance = newDistance;
    newAlignmentStation.distance = newDistance;
    newAlignmentStation.y = Number(setStore.stationOffsetObject.beginningY) + Number(newDistance);
    newAlignmentStation.stationName = Math.round(newDistance);
    setStore.stationOffsetObject.alignmentStations.push({ ...newAlignmentStation });
  }

  @action.bound onFocusHandler(e: any) {
    const index = e.target.getAttribute('data-i');
    const offsetStation = setStore.stationOffsetObject.offsetStations[index];
    this.refillPlotData(offsetStation);
  }

  @action.bound onBlurHandler(e: any) {
    if (e.target.value === '') {
      e.target.value = '0';
    }
  }

  @action.bound someAction(e: any) {
    e.preventDefault();
  }

  @action.bound refillPlotData(station) {
    const stationName = `Station ${station.stationDistance} profile`;
    this.plotData = {};
    this.plotData[stationName] = [];
    station.offsets.map((el) =>
      this.plotData[stationName].push([
        el.offsetDistance,
        station.entryMode === 'ROD' ? station.hiElevation - el.z : el.z,
      ])
    );
  }
}
